import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { DICTS } from "./dict";

const LangCtx = createContext(null);

const lookup = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mci_lang") || "en");
  useEffect(() => {
    localStorage.setItem("mci_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let v = lookup(DICTS[lang], key);
      if (v === undefined) v = lookup(DICTS.en, key);
      if (v === undefined) return key;
      if (typeof v === "string" && vars) Object.entries(vars).forEach(([k, val]) => (v = v.replaceAll(`{${k}}`, val)));
      return v;
    },
    [lang]
  );

  const money = useCallback(
    (n, digits = 2) =>
      new Intl.NumberFormat(lang === "fr" ? "fr-CA" : "en-CA", { style: "currency", currency: "CAD", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(n || 0),
    [lang]
  );
  const num = useCallback((n, d = 2) => new Intl.NumberFormat(lang === "fr" ? "fr-CA" : "en-CA", { maximumFractionDigits: d }).format(n || 0), [lang]);

  const value = useMemo(() => ({ lang, setLang, t, money, num }), [lang, t, money, num]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
